import { RecordOf } from '@opengov/compose-app/immutable';

import { Entity } from '../entity/records';
import { ISession } from '../types';

export const Session = RecordOf<ISession>({
  id: null,
  uuid: null,
  email: null,
  first_name: null,
  last_name: null,
  full_name: null,
  role: {
    name: null,
    display_name: null
  },
  abilities: {
    entity: null,
    report: null,
    saved_view: null,
    'data_manager/coa_mask': null,
    feedback: null,
    'budgeting/budget': null,
    'budgeting/budget_invite': null,
    feature_license_agreement: null,
    user: null,
    api_key: null
  },
  demote_at: null,
  environment: null,
  avatar: null,
  control_panel_menu_items: null,
  user_intercom_hash: null,
  groups: null,
  title: null,
  department: null,
  last_seen: null,
  created_at: null,
  entity: Entity(),
  entity_id: null
});
